import styled from 'styled-components';

export const Card = styled.section`
  display: flex;
  column-gap: 30px;
  width: 100%;
  margin-top: 20px;
  padding: 0;

  @media (max-width: 720px) {
    display: block;
    column-gap: 0px;
    padding: 0 12px;
  }
`;
export const PregnancyCard = styled.div`
  background: #fff;
  border-radius: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  outline: rgba(0, 0, 0, 0.1) solid 1px;
  position: relative;
  top: 0;
  transition: all 0.18s ease-out;
  width: 100%;

  &:hover {
    top: -4px;
    box-shadow: 0px 4px 8px #26262624;
    outline: 1px solid #cccccc;

    @media (max-width: 720px) {
      box-shadow: none;
    }
  }

  @media (max-width: 720px) {
    margin: 0 0 20px;
    max-width: 100%;
  }

  & ul {
    font-size: clamp(15px, 2vw, 14px);
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 80%);
    font-size: 14px;
    padding: 30px 20px 16px;
    text-align: left;

    @media (max-width: 720px) {
      font-size: 14px;
      padding: 8px 10px 16px;
    }
    & li {
      display: flex;
      justify-content: space-around;
      cursor: pointer;

      & p {
        padding: 12px 0;
        display: flex;
        align-items: center;
        flex-basis: 90%;
        & img {
          padding-right: 4px;
        }
        @media (max-width: 720px) {
          cursor: default;
          font-size: 14px;
        }
      }
      & img {
        width: 13px;
      }
    }
  }
  .trimImageSec {
    position: relative;
  }
  .transitionClass {
    transition: all 0.2s ease-in-out;
  }
  .gridcardopacity {
    opacity: 0.5;
  }
`;
export const PregnancyTitle = styled.div`
  font-size: clamp(16px, 2vw, 18px);
  font-weight: bold;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: hsl(0deg 0% 100% / 92%);
  padding: 10px 14px;
  bottom: -35px;
  left: 50%;
  width: 100%;
  text-transform: uppercase;
  color: hsl(0deg, 0%, 0%, 70%);
  @media (max-width: 720px) {
    width: 100%;
    transform: translate(0, 0);
    left: 0;
    bottom: 0;
    background-color: hsl(0deg 0% 100% / 45%);
  }
`;

export const TrimesterImage = styled.img`
  width: 100%;
  height: auto;
  min-height: 200px;
  object-fit: cover;
  max-height: 200px;
  border-radius: 16px 16px 0 0;
`;

export const ViewMore = styled.button`
  background-color: #fff;
  color: #ef4e5e !important;
  font-weight: 500;
  font-size: 14px;
  outline: none;
  border: none;
  display: inline-block;
  margin-top: auto;
  text-align: left;
  width: 100%;
  padding: 0 24px 12px;

  @media (max-width: 720px) {
    padding: 0 15px 12px;
  }
`;
